exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-field-editor[data-v-6e56931d] {\n  position: relative;\n}\n.text-field-editor .hover-buttons[data-v-6e56931d] {\n    display: none;\n}\n.text-field-editor:hover .hover-buttons[data-v-6e56931d] {\n  display: block;\n}\n.bg-wrap[data-v-6e56931d] {\n  padding: 16px 8px 0;\n  border-radius: 4px;\n}\n.text-field[data-v-6e56931d] {\n  width: 100%;\n}\n[data-v-6e56931d] .mdc-text-field {\n  width: 100%;\n}\n[data-v-6e56931d] .resizable-textarea .hide-icon:after {\n  bottom: 20.7px;\n}\n[data-v-6e56931d] .btn-wrap {\n  margin: 12px 0 32px 8px;\n}\n", ""]);

// exports
